<template>
  <v-layout wrap v-if="error || success" class="message-box">
    <v-flex xs12>
      <!-- Error Box -->
      <v-card color="red lighten-5" class="error-card rounded-tr-0 rounded-tl-0" v-if="error">
        <v-card-title>
          <v-icon color="primary" large class="mr-4 hidden-xs-only">error</v-icon>
          <v-flex xs9 v-if="isGenError">
            <h2 class="text-h6 red--text pb-1">
              {{ $t('store.productCode.problemMsg') }}<br />
              <em class="mt-2" style="display: block">{{ errorMessage | uppercase }}</em>
            </h2>
            <div class="text-body-2">
              {{ $t('store.productCode.supportContactMsg') }}
            </div>
          </v-flex>

          <v-flex xs9 v-else>
            <h2 class="text-h6 red--text pb-1">
              {{ $t('store.productCode.problemMsg') }}<br />
              <em class="mt-2" style="display: block">{{ errorMessage | uppercase }}</em>
            </h2>
            <div class="text-body-2">
              {{ $t('store.productCode.invalidMsg') }}
            </div>
            <div class="text-body-2">
              {{ $t('store.productCode.pleaseContactAt') }}:
              <a class="support" href="https://e6golf.com/support" target="_blank">
                E6 Golf {{ $t('store.productCode.e6Support') }}
              </a>
            </div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs1>
            <v-btn icon text color="grey" @click="dismissKeyMessage('error')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
      </v-card>

      <!-- Success Box -->
      <v-card color="green lighten-5" class="success-card rounded-tr-0 rounded-tl-0" v-if="success">
        <v-card-title>
          <v-icon color="green darken-2" large class="mr-4 hidden-xs-only"> check_circle </v-icon>
          <v-flex xs9>
            <h2 class="text-h6 green--text pb-1">
              {{ $t('store.productCode.acceptedKey') }}
              <div>
                {{ productKey ? productKey : 'XXXXX-XXXXX-XXXXX-XXXXX' | uppercase }}
              </div>
            </h2>
            <div class="text-body-2">
              {{ $t('store.productCode.viewInfo') }}
            </div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs1>
            <v-btn icon text color="grey" @click="dismissKeyMessage('success')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ProductCodeMessage',
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
    productKey: {
      type: String,
    },
  },

  computed: {
    isGenError() {
      return this.errorMessage?.includes('GEN');
    },
  },

  methods: {
    dismissKeyMessage(type) {
      this.$emit('dismissKey', type);
    },
  },

  filters: {
    uppercase(s) {
      if (!s || s === undefined || s === null) return s;
      return s.toUpperCase();
    },
  },
};
</script>

<style scoped>
.theme--dark .body-2 {
  color: #222;
}

.message-box {
  margin-top: -2px;
}

.support {
  font-weight: bold;
}

.support:hover {
  text-decoration: underline;
}
</style>
